const getIdsFromUrl = (url) => {
  const index = url?.lastIndexOf('_');
  return Number(url?.slice(index + 1));
};

export default getIdsFromUrl;
